import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');


import {Modal} from 'bootstrap';


$('.reference').each(function () {

    if (inBackend) return;

    const $reference = $(this);
    const $modal = $reference.find('.reference-modal');
    const $modalLink = $reference.find('.reference-modal-link');
    const $modalClose = $reference.find('.reference-modal-slider-close-icon');
    const modal = new Modal($modal[0])

    $modalLink.on('click', function (event) {
        event.preventDefault();
        modal.show();

        $modalClose.on('click', function () {
            modal.hide();
        });

    });

});
